var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-dashboard',{attrs:{"title":_vm.$route.name}},[_c('v-container',{staticClass:"fill-container-height",attrs:{"fluid":""}},[_c('v-card',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.users}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }